import './StoreAccess.css'
import { useTranslation } from 'react-i18next'

type StoreAccessProps = {
  compact?: boolean
}

const appStoreUrl = import.meta.env.VITE_SIDEWISP_APP_STORE_URL as string | undefined
const playStoreUrl = import.meta.env.VITE_SIDEWISP_GOOGLE_PLAY_URL as string | undefined

function availableUrl(value?: string) {
  if (!value) return null
  try {
    const url = new URL(value)
    return url.protocol === 'https:' ? url.toString() : null
  } catch {
    return null
  }
}

const configuredStoreLinks = {
  apple: availableUrl(appStoreUrl),
  google: availableUrl(playStoreUrl),
}

export default function StoreAccess({ compact = false }: StoreAccessProps) {
  const { t } = useTranslation()
  const title = t('stores.title')
  const available = Boolean(configuredStoreLinks.apple || configuredStoreLinks.google)
  return (
    <section className={`store-access${compact ? ' store-access--compact' : ''}`} aria-label={title}>
      {!compact && <div><span>{t('stores.mobileApp')}</span><strong>{title}</strong><p>{t('stores.description')}</p></div>}
      <div className="store-access__actions">
        {configuredStoreLinks.apple
          ? <a href={configuredStoreLinks.apple} rel="noopener noreferrer" data-store="apple"><small>{t('stores.downloadOn')}</small><strong>App Store</strong></a>
          : <span className="store-access__pending" data-store="apple"><small>{t('stores.appleDevice')}</small><strong>{t('stores.applePending')}</strong></span>}
        {configuredStoreLinks.google
          ? <a href={configuredStoreLinks.google} rel="noopener noreferrer" data-store="google"><small>{t('stores.getItOn')}</small><strong>Google Play</strong></a>
          : <span className="store-access__pending" data-store="google"><small>Android</small><strong>{t('stores.googlePending')}</strong></span>}
      </div>
      {!available && <small className="store-access__truth">{t('stores.comingSoonTruth')}</small>}
    </section>
  )
}
